export const DOMAIN_FOLDER = 'domain-folder';

const isFolder = (item: any): boolean => item?.isFolder || item?.type === 'folder';

export const isDomainFolder = (item: any): boolean => isFolder(item) && item.kind === DOMAIN_FOLDER;
export const isMountedFolder = (item: any): boolean => isFolder(item) && item.kind === 'mounted';
export const isSharedFolder = (item: any): boolean => isFolder(item) && item.kind === 'shared';
export const isPublicFolder = (item: any): boolean => isFolder(item) && Boolean(item.weblink);
export const isCameraUploadsFolder = (item: any): boolean => isFolder(item) && item?.kind === 'camera-upload';
